import { render, staticRenderFns } from "./SummaryStatsTable.vue?vue&type=template&id=39da72a9&scoped=true"
import script from "./SummaryStatsTable.vue?vue&type=script&lang=js"
export * from "./SummaryStatsTable.vue?vue&type=script&lang=js"
import style0 from "./SummaryStatsTable.vue?vue&type=style&index=0&id=39da72a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da72a9",
  null
  
)

export default component.exports